import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseUrls } from '@app/app.constants';
import { Registration } from '@app/core/models/registration';
import { UserLevel } from '@app/core/models/user-level';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RegistrationRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  delete(registrationId: string, userId: number | string): Observable<void> {
    const url = {
      [UserLevel.ServiceProviderAdmin.toString()]: `/enterprise/:enterpriseId/users/:userId/registrations/${registrationId}`,
      [UserLevel.EnterpriseAdmin.toString()]:
        BaseUrls.Enterprise.Enterprise + `/users/:userId/registrations/${registrationId}`,
    };

    return this.utils.apiUrl(url, { userId }).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('registration-repository:delete')
    );
  }

  list(): Observable<Registration[]> {
    return this.utils.apiUrl('/registrations').pipe(
      mergeMap((url) => this.http.get<Registration[]>(url)),
      wrapError('registration-repository:list')
    );
  }
}
